import axios from "axios";

const API_BASE = process.env.NODE_ENV === 'production'
  ? 'https://admin.highperformr.ai'
  : 'http://localhost:4000';

const API = `${API_BASE}/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true
});

// Configure axios to include credentials (cookies) for authentication
axios.defaults.withCredentials = true;

// Company Lists APIs
export const getCompanyLists = () => axios.get(`${API}/company-lists`);
export const createCompanyList = (data) => axios.post(`${API}/company-lists`, data);
export const updateCompanyList = (listId, data) => axios.put(`${API}/company-lists/${listId}`, data);
export const deleteCompanyList = (listId) => axios.delete(`${API}/company-lists/${listId}`);
export const getCompanyListCompanies = (listId) => axios.get(`${API}/company-lists/${listId}/companies`);
export const removeCompanyFromList = (listId, companyId) => axios.delete(`${API}/company-lists/${listId}/companies/${companyId}`);
export const dataCorrection = (formData) => axios.post(`${API}/data-correction/add-companies`, formData);
export const getDataCorrectionRequests = (status) => axios.get(`${API}/data-correction/requests`, { params: status ? { status } : {} });
export const approveCorrectionRequest = (requestId) => axios.post(`${API}/data-correction/requests/${requestId}/approve`);
export const rejectCorrectionRequest = (requestId) => axios.post(`${API}/data-correction/requests/${requestId}/reject`);
export const downloadCorrectionFile = (requestId) => axios.get(`${API}/data-correction/download/${requestId}`, { responseType: 'blob' });
export const getDataCorrectionLogs = (requestId) => axios.get(`${API}/data-correction/requests/${requestId}/logs`);
export const getAllDataCorrectionLogs = () => axios.get(`${API}/data-correction/logs`);
export const revertCorrectionRequest = (requestId) => axios.post(`${API}/data-correction/requests/${requestId}/revert`);
export const getCorrectionFieldKeys = () => axios.get(`${API}/data-correction/correction-field-keys`);
export const fetchIndustries = () => axios.get(`${API}/data-correction/industries`);
export const fetchIndustryFields = (industry) => axios.get(`${API}/data-correction/industries/${encodeURIComponent(industry)}/fields`);
export const saveRequestMappings = (industry, payload) => axios.post(`${API}/data-correction/industries/${encodeURIComponent(industry)}/mappings/requests`, payload);

// Public Images APIs
export const getPublicImageFolders = (prefix) => axios.get(`${API}/public-images/folders`, { params: prefix ? { prefix } : {} });
export const getPublicImageFiles = (folderPath) => axios.get(`${API}/public-images/files`, { params: folderPath ? { folderPath } : {} });
export const createPublicImageFolder = (folderPath) => axios.post(`${API}/public-images/folders`, { folderPath });
export const uploadPublicImage = (formData) => axios.post(`${API}/public-images/upload`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const deletePublicImageFile = (filePath) => axios.delete(`${API}/public-images/files`, { params: { filePath } });
export const deletePublicImageFolder = (folderPath) => axios.delete(`${API}/public-images/folders`, { params: { folderPath } });

// Knowledge Hub APIs
const KNOWLEDGE_HUB_BASE = `${API}/knowledge-hub`;

// Folders
export const getKnowledgeRootFolders = () =>
  axios.get(`${KNOWLEDGE_HUB_BASE}/folders`);

export const getKnowledgeFolderById = (folderId) =>
  axios.get(`${KNOWLEDGE_HUB_BASE}/folders/${folderId}`);

export const getKnowledgeChildFolders = (folderId) =>
  axios.get(`${KNOWLEDGE_HUB_BASE}/folders/${folderId}/children`);

export const createKnowledgeFolder = (payload) =>
  axios.post(`${KNOWLEDGE_HUB_BASE}/folders`, payload);

export const updateKnowledgeFolder = (folderId, payload) =>
  axios.put(`${KNOWLEDGE_HUB_BASE}/folders/${folderId}`, payload);

export const deleteKnowledgeFolder = (folderId) =>
  axios.delete(`${KNOWLEDGE_HUB_BASE}/folders/${folderId}`);

// Notes
export const getKnowledgeNotes = (folderId) =>
  axios.get(`${KNOWLEDGE_HUB_BASE}/folders/${folderId}/notes`);

export const createKnowledgeNote = (folderId, payload) =>
  axios.post(`${KNOWLEDGE_HUB_BASE}/folders/${folderId}/notes`, payload);

export const updateKnowledgeNote = (noteId, payload) =>
  axios.put(`${KNOWLEDGE_HUB_BASE}/notes/${noteId}`, payload);

export const deleteKnowledgeNote = (noteId) =>
  axios.delete(`${KNOWLEDGE_HUB_BASE}/notes/${noteId}`);

// Pins
export const getKnowledgePins = () =>
  axios.get(`${KNOWLEDGE_HUB_BASE}/pins`);

export const pinKnowledgeNote = (noteId) =>
  axios.post(`${KNOWLEDGE_HUB_BASE}/pins`, { noteId });

export const unpinKnowledgeNote = (noteId) =>
  axios.delete(`${KNOWLEDGE_HUB_BASE}/pins/${noteId}`);

// Meetings analytics (Profile Analyser via HP Admin API)
export const getMeetingsAnalyticsSummary = (params) =>
  api.get('/api/meetings-analytics/summary', { params });
export const getMeetingsAnalyticsByAccount = (params) =>
  api.get('/api/meetings-analytics/by-account', { params });

// Email metrics (ClickHouse)
export const getEmailMetricTemplates = () =>
  api.get('/api/email-metrics/templates');
export const getEmailMetrics = (payload) =>
  api.post('/api/email-metrics/metrics', payload);
export const getEmailMetricMessages = (payload) =>
  api.post('/api/email-metrics/messages', payload);
export const getEmailMetricDetail = (messageId) =>
  api.get(`/api/email-metrics/messages/${encodeURIComponent(messageId)}`);

// Trends pipeline status (GitHub Contents API via hp-admin backend)
export const getTrendsPipelineStatus = () =>
  api.get('/api/trends-pipeline/status');

export default api;
